'use client'

import { useEffect } from 'react'
import {
  initDatadogRecording,
  validateDatadogSession
} from '../services/datadog-services'

interface Props {
  datadogApplicationId: string
  datadogClientToken: string
  stage: string
}

const loadDatadog = (
  stage: string,
  datadogApplicationId: string,
  datadogClientToken: string
): void => {
  if (stage === 'prod' && !validateDatadogSession()) {
    initDatadogRecording(datadogApplicationId, datadogClientToken, stage)
  }
}

/**
 * This component loads external analytics and monitoring services.
 * @service Datadog
 */

const AnalyticsProvider: React.FC<Props> = ({
  datadogApplicationId,
  datadogClientToken,
  stage
}) => {
  useEffect(() => {
    if (datadogApplicationId && datadogClientToken) {
      loadDatadog(stage, datadogApplicationId, datadogClientToken)
    }
  }, [datadogApplicationId, datadogClientToken, stage])

  return null
}

export default AnalyticsProvider
